import { useDispatch as _useDispatch } from 'react-redux';

/**
 * Typed useDispatch
 */
export const useDispatch = () => _useDispatch();
